import {SpeedIcon, CoordinationIcon, StrengthIcon, FlexibilityIcon, StaminaIcon} from '../assets/icons'

// Order is important
export const RADAR_LINES = [
  {
    labelKey: 'dna.coordination.label',
    icon: CoordinationIcon,
    mappingName: 'coordination',
  },
  {
    labelKey: 'dna.strength.label',
    mappingName: 'strength',
    icon: StrengthIcon
  },
  {
    labelKey: 'dna.speed.label',
    mappingName: 'speed',
    icon: SpeedIcon
  },
  {
    labelKey: 'dna.flexibility.label',
    mappingName: 'flexibility',
    icon: FlexibilityIcon
  },
  {
    labelKey: 'dna.stamina.label',
    mappingName: 'stamina',
    icon: StaminaIcon
  },
];
